import React, { useEffect, useState } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import { CircularProgress, Container, Typography, Box } from "@mui/material";
import config from "../../config.js";

ChartJS.register(
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement
);

const LogisticValue  = () => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;
 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/v1/logisticJson`
        );
        const rawData = response.data.data.Data;

        const months = [...new Set(rawData.map(item => item["Month"]))];
        const routes = [...new Set(rawData.map(item => item["Routes"]))];

        const datasets = routes.map(route => {
          const data = months.map(month => {
            const monthData = rawData.filter(item => item["Month"] === month && item["Routes"] === route);
            return monthData.reduce((total, item) => total + item["Value of Сargo"], 0);
          });
          return {
            label: route,
            data: data,
            backgroundColor: `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 0.6)`,
            borderColor: `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 1)`,
            borderWidth: 1,
          };
        });

       

        setChartData({
          labels: months,
          datasets: datasets,
        });
      } catch (error) {
        setError(error);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!chartData.labels.length) {
    return (
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  } else {
    const options = {
      responsive: true,
      scales: {
        x: {
          beginAtZero: true,
          barPercentage: 1.5, // Increase this value to make the bars wider
          categoryPercentage: 1.5, // Increase this value to make the bars wider
        },
        y: {
          beginAtZero: true,
        },
      },
      plugins: {
        legend: {
          display: true,
          labels: {
            color: 'white', // Color for the legend text
            font: {
              size: 14 // Font size for the legend text
            }
          }
        }
      },
      elements: {
        bar: {
          maxBarThickness: 80, // Increase this value to make the bars thicker
        }
      },
      animations: {
        radius: {
          duration: 400,
          easing: 'linear',
          loop: (context) => context.active
        }
      },
      hoverRadius: 12,
      hoverBackgroundColor: 'yellow',
      interaction: {
        mode: 'nearest',
        intersect: false,
        axis: 'x'
      },
    };

    return (
      <div>
        <Box sx={{ backgroundColor: "#FF4D4D", padding: 2, borderRadius: 1 }}>
          <Typography variant="h5" sx={{ color: "#fff", textAlign: "center" }}>
            Value of Cargo by Month and Route
          </Typography>
        </Box>
        <Container>
          <div
            style={{
              padding: "20px",
              width: "100%",
              height: "80%",
            }}
          >
            <Bar
              data={chartData}
              options={options}
            />
          </div>
        </Container>
      </div>
    );
  }
};

export default LogisticValue ;
